<template>
  <div class="form-group repeatable-group">
    <label>Menu items</label>

    <div class="container-repeatable-elements">
      <div>
        <div v-for="(item, index) in items" :key="item.id">
          <Item
            v-model="items[index]"
            :index="index"
            @on-remove="removeType(index)"
            @on-increment="increment(index)"
            @on-decrement="decrement(index)"
            :length="items.length"
          />
        </div>
      </div>
    </div>

    <button
      type="button"
      class="btn btn-outline-primary btn-sm ml-1"
      @click="addItem"
    >
      + Nieuw item
    </button>
  </div>
</template>

<script>
import Item from "./Item.vue";
import { v4 as uuidV4 } from "uuid";

export default {
  components: { Item },
  name: "List",
  props: {
    value: {
      type: Array,
    },
  },
  data() {
    return {
      items: this.value ?? [],
    };
  },
  methods: {
    addItem() {
      this.items.push({
        id: uuidV4(),
        items: [],
        label: "",
        href: "",
        image: "",
        type: "link",
      });
    },
    removeType(index) {
      this.items.splice(index, 1);
    },
    decrement(index) {
      let item = this.items.splice(index, 1)[0];
      this.items.splice(index + 1, 0, item);
    },
    increment(index) {
      if (index < 1) {
        return;
      }

      let item = this.items.splice(index, 1)[0];
      this.items.splice(index - 1, 0, item);
    },
  },
};
</script>